import { render, staticRenderFns } from "./LocalPainControl.vue?vue&type=template&id=3d782c66&scoped=true&"
import script from "./LocalPainControl.vue?vue&type=script&lang=js&"
export * from "./LocalPainControl.vue?vue&type=script&lang=js&"
import style0 from "./LocalPainControl.vue?vue&type=style&index=0&id=3d782c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d782c66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VChip,VCombobox,VFlex,VLayout})
